import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import FloatingChatButton from "@/components/FloatingChatButton";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import HelpPage from "@/pages/HelpPage";
import TradingPage from "@/pages/TradingPage";
import AiVideoPage from "@/pages/AiVideoPage";
import AdvertisePublicPage from "@/pages/AdvertisePublicPage";

// Trade (admin) section
import { AuthProvider } from "@/contexts/TradeAuthContext";
import TradeLogin from "@/pages/trade/TradeLogin";
import TradeLayout from "@/pages/trade/TradeLayout";
import TradeDashboard from "@/pages/trade/TradeDashboard";
import ShipmentsList from "@/pages/trade/ShipmentsList";
import ShipmentForm from "@/pages/trade/ShipmentForm";
import { SuppliersList, SupplierForm } from "@/pages/trade/Suppliers";
import { AgentsList, AgentForm } from "@/pages/trade/Agents";
import { BrokersList, BrokerForm } from "@/pages/trade/Brokers";
import CostCalculator from "@/pages/trade/CostCalculator";
import CurrencyConverter from "@/pages/trade/CurrencyConverter";
import DocumentsPage from "@/pages/trade/DocumentsPage";
import NotesPage from "@/pages/trade/NotesPage";
import { AccountantPage, GovContactsPage } from "@/pages/trade/KeyContacts";
import CustomersPage from "@/pages/trade/CustomersPage";
import WeChatPage from "@/pages/trade/WeChatPage";
import AddressesPage from "@/pages/trade/AddressesPage";
import AudioPage from "@/pages/trade/AudioPage";
import AdvertisePage from "@/pages/trade/AdvertisePage";
import EducationPage from "@/pages/trade/EducationPage";
import AIAssistant from "@/pages/trade/AIAssistant";
import TrackingPage from "@/pages/trade/TrackingPage";

function PublicLayout({ children }) {
  return (
    <>
      <Navigation />
      <main>{children}</main>
      <Footer />
      <FloatingChatButton />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#050505]">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><ServicesPage /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/help" element={<PublicLayout><HelpPage /></PublicLayout>} />
            <Route path="/trading" element={<PublicLayout><TradingPage /></PublicLayout>} />
            <Route path="/ai-video" element={<PublicLayout><AiVideoPage /></PublicLayout>} />
            <Route path="/advertise/:shareId" element={<AdvertisePublicPage />} />
            <Route path="/terms-of-service" element={<PublicLayout><TermsPage /></PublicLayout>} />
            <Route path="/privacy-policy" element={<PublicLayout><PrivacyPage /></PublicLayout>} />

            {/* Trade admin section */}
            <Route path="/trade/login" element={<><Navigation /><TradeLogin /></>} />
            <Route element={<><Navigation /><TradeLayout /></>}>
              <Route path="/trade" element={<TradeDashboard />} />
              <Route path="/trade/shipments" element={<ShipmentsList />} />
              <Route path="/trade/shipments/new" element={<ShipmentForm />} />
              <Route path="/trade/shipments/:id" element={<ShipmentForm />} />
              <Route path="/trade/suppliers" element={<SuppliersList />} />
              <Route path="/trade/suppliers/new" element={<SupplierForm />} />
              <Route path="/trade/suppliers/:id" element={<SupplierForm />} />
              <Route path="/trade/agents" element={<AgentsList />} />
              <Route path="/trade/agents/new" element={<AgentForm />} />
              <Route path="/trade/agents/:id" element={<AgentForm />} />
              <Route path="/trade/brokers" element={<BrokersList />} />
              <Route path="/trade/brokers/new" element={<BrokerForm />} />
              <Route path="/trade/brokers/:id" element={<BrokerForm />} />
              <Route path="/trade/calculator" element={<CostCalculator />} />
              <Route path="/trade/converter" element={<CurrencyConverter />} />
              <Route path="/trade/documents" element={<DocumentsPage />} />
              <Route path="/trade/notes" element={<NotesPage />} />
              <Route path="/trade/accountant" element={<AccountantPage />} />
              <Route path="/trade/gov-helpers" element={<GovContactsPage />} />
              <Route path="/trade/customers" element={<CustomersPage />} />
            <Route path="/trade/wechat" element={<WeChatPage />} />
            <Route path="/trade/addresses" element={<AddressesPage />} />
              <Route path="/trade/audio" element={<AudioPage />} />
              <Route path="/trade/advertise" element={<AdvertisePage />} />
              <Route path="/trade/education" element={<EducationPage />} />
              <Route path="/trade/ai" element={<AIAssistant />} />
              <Route path="/trade/tracking" element={<TrackingPage />} />
            </Route>
          </Routes>
          <Toaster 
            position="top-right"
            toastOptions={{
              style: {
                background: '#0A0A0A',
                border: '1px solid rgba(212, 175, 55, 0.3)',
                color: '#FAFAFA',
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
